"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.templateSelectionSortMenuAssets = void 0;
var react_1 = __importDefault(require("react"));
var step_1 = require("../step");
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var inversify_react_1 = require("inversify-react");
var ApiService_1 = require("CreatePageFlow/ApiService");
var BemBuilder_1 = __importDefault(require("Utils/BemBuilder"));
var TokenResolution_1 = require("CreatePageFlow/steps/TokenResolution");
var CreatePageTelemetry_1 = __importDefault(require("CreatePageFlow/CreatePageTelemetry"));
var SortBySelector_1 = __importStar(require("../../../Client/Application/Dashboard/SortBySelector/SortBySelector"));
var icons_1 = require("@qwilr/kaleidoscope/icons");
var DashboardTypes_1 = require("../../../Client/Application/Dashboard/DashboardTypes");
var utils_1 = require("CreatePageFlow/utils");
var IntegrationLinkGenerator_1 = require("@CommonFrontendBackend/Utils/IntegrationLinkGenerator");
var AssetsDir = "/Assets/";
var c = (0, BemBuilder_1.default)("create-page-flow-template-selection");
exports.templateSelectionSortMenuAssets = [
    {
        type: SortBySelector_1.MenuItem.Edited,
        text: "Last Edited",
        icon: react_1.default.createElement(icons_1.Edit, null),
        sortBy: DashboardTypes_1.SortBy.LastEditedAt,
    },
    {
        type: SortBySelector_1.MenuItem.Created,
        text: "Date Created",
        icon: react_1.default.createElement(icons_1.Clock, null),
        sortBy: DashboardTypes_1.SortBy.CreatedAt,
    },
    {
        type: SortBySelector_1.MenuItem.Name,
        text: "Alphabetical",
        icon: react_1.default.createElement(icons_1.Fonts, null),
        sortBy: DashboardTypes_1.SortBy.Name,
    },
];
var TemplateSelection = (function (_super) {
    __extends(TemplateSelection, _super);
    function TemplateSelection(props) {
        var _this = _super.call(this, props) || this;
        _this.images = {
            objectIcon: "".concat(AssetsDir, "Images/createPage/objectIcon.svg"),
            templateIcon: "".concat(AssetsDir, "Images/createPage/template.svg"),
        };
        _this.displayedTemplates = [];
        _this.searchString = "";
        _this.errorMessage = "";
        _this.isLoading = false;
        _this.selectedSortOption = exports.templateSelectionSortMenuAssets[0];
        _this.selectedSortDirection = DashboardTypes_1.SortDirection.Descending;
        _this.setSearchTerm = function (searchString) {
            _this.setSearchString(searchString);
            _this.reconfigureDisplayedTemplates();
        };
        _this.setSortOption = function (sortBy, sortDirection) {
            _this.setSelectedSortOption(exports.templateSelectionSortMenuAssets.filter(function (obj) { return obj.sortBy === sortBy; })[0]);
            _this.setSelectedSortDirection(sortDirection);
            _this.reconfigureDisplayedTemplates();
        };
        _this.sortDisplayedTemplates = function (newTemplateList) {
            switch (_this.selectedSortOption.sortBy) {
                case DashboardTypes_1.SortBy.LastEditedAt:
                    if (_this.selectedSortDirection === DashboardTypes_1.SortDirection.Ascending) {
                        return newTemplateList
                            .slice()
                            .sort(function (a, b) {
                            return new Date(a.lastEditedAt).toISOString().localeCompare(new Date(b.lastEditedAt).toISOString());
                        });
                    }
                    else {
                        return newTemplateList
                            .slice()
                            .sort(function (a, b) {
                            return new Date(b.lastEditedAt).toISOString().localeCompare(new Date(a.lastEditedAt).toISOString());
                        });
                    }
                case DashboardTypes_1.SortBy.Name:
                    if (_this.selectedSortDirection === DashboardTypes_1.SortDirection.Ascending) {
                        return newTemplateList
                            .slice()
                            .sort(function (a, b) { return a.name.localeCompare(b.name); });
                    }
                    else {
                        return newTemplateList
                            .slice()
                            .sort(function (a, b) { return b.name.localeCompare(a.name); });
                    }
                case DashboardTypes_1.SortBy.CreatedAt:
                    if (_this.selectedSortDirection === DashboardTypes_1.SortDirection.Ascending) {
                        return newTemplateList
                            .slice()
                            .sort(function (a, b) {
                            return new Date(a.createdAt).toISOString().localeCompare(new Date(b.createdAt).toISOString());
                        });
                    }
                    else {
                        return newTemplateList
                            .slice()
                            .sort(function (a, b) {
                            return new Date(b.createdAt).toISOString().localeCompare(new Date(a.createdAt).toISOString());
                        });
                    }
                default:
                    return newTemplateList;
            }
        };
        _this.reconfigureDisplayedTemplates = function () {
            var _a;
            var newTemplateList;
            if (_this.searchString) {
                newTemplateList = ((_a = _this.props.store.templateList) !== null && _a !== void 0 ? _a : []).filter(function (template) {
                    return template.name.toLowerCase().includes(_this.searchString.toLowerCase());
                });
            }
            else {
                newTemplateList = _this.props.store.templateList;
            }
            newTemplateList = _this.sortDisplayedTemplates(newTemplateList);
            _this.setDisplayedTemplates(newTemplateList);
        };
        _this.selectTemplate = function (selectedTemplate) { return __awaiter(_this, void 0, void 0, function () {
            var _a, store, moveStep, e_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.props, store = _a.store, moveStep = _a.moveStep;
                        store.setTemplateId(selectedTemplate._id);
                        store.setTemplate({ _id: selectedTemplate._id, name: selectedTemplate.name, crmInfo: selectedTemplate.crmInfo });
                        this.setIsLoading(true);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, 4, 5]);
                        return [4, (0, TokenResolution_1.resolveTokens)(store, this.apiService, this.telemetry)];
                    case 2:
                        _b.sent();
                        moveStep(1);
                        return [3, 5];
                    case 3:
                        e_1 = _b.sent();
                        this.setErrorMessage("Something went wrong. Please refresh and try again. If the problem persists, contact support.");
                        return [3, 5];
                    case 4:
                        this.setIsLoading(false);
                        return [7];
                    case 5: return [2];
                }
            });
        }); };
        _this.setDisplayedTemplates(props.store.templateList);
        return _this;
    }
    TemplateSelection.prototype.setSelectedSortOption = function (sortOption) {
        this.selectedSortOption = sortOption;
    };
    TemplateSelection.prototype.setSelectedSortDirection = function (direction) {
        this.selectedSortDirection = direction;
    };
    TemplateSelection.prototype.setSearchString = function (searchString) {
        this.searchString = searchString;
    };
    TemplateSelection.prototype.setIsLoading = function (isLoading) {
        this.isLoading = isLoading;
    };
    TemplateSelection.prototype.setErrorMessage = function (error) {
        this.errorMessage = error;
    };
    TemplateSelection.prototype.setDisplayedTemplates = function (templates) {
        this.displayedTemplates = templates;
    };
    TemplateSelection.prototype.render = function () {
        var _this = this;
        var _a = this.props.store, templateList = _a.templateList, template = _a.template, objectType = _a.objectType, integrationName = _a.integrationName;
        var templates;
        if ((templateList === null || templateList === void 0 ? void 0 : templateList.length) === 0) {
            templates = (react_1.default.createElement("div", { className: c("emptyState") },
                react_1.default.createElement(kaleidoscope_1.EmptyState, { isDashed: true, title: "No templates yet", subtitle: "Create a template and link it to this object in Qwilr or ask your admin to share a template with you." },
                    react_1.default.createElement(kaleidoscope_1.Link, { href: (0, IntegrationLinkGenerator_1.returnLearnMoreLink)(integrationName, true) }, "Learn More"))));
        }
        else {
            templates = (react_1.default.createElement("div", null,
                react_1.default.createElement("div", { className: c("search-and-sort-container") },
                    react_1.default.createElement(kaleidoscope_1.SearchInput, { placeholder: "e.g. Example Template 1", value: this.searchString, className: c("search-and-sort-container-search"), label: "", onChange: function (e) { return _this.setSearchTerm(e); } }),
                    react_1.default.createElement("div", { className: c("search-and-sort-container-sort") },
                        react_1.default.createElement(SortBySelector_1.default, { menuAssets: exports.templateSelectionSortMenuAssets, selectedMenuItem: this.selectedSortOption.type, onSelectMenuItemHandle: function (sortBy, sortDirection) { return _this.setSortOption(sortBy, sortDirection); }, className: c("sort-filter-option-menu"), sortDirection: this.selectedSortDirection }))),
                react_1.default.createElement("div", { className: c("list-view") }, this.displayedTemplates.map(function (displayedTemplate, key) { return (react_1.default.createElement("div", { key: displayedTemplate._id },
                    react_1.default.createElement(kaleidoscope_1.ButtonCard, { onClick: function () { return _this.selectTemplate(displayedTemplate); }, className: c("list-view-template-card"), key: key }, _this.isLoading && displayedTemplate._id === (template === null || template === void 0 ? void 0 : template._id) ? (react_1.default.createElement("div", { className: c("list-view-template-card-wrapper") },
                        react_1.default.createElement(kaleidoscope_1.Spinner, { primary: true, size: kaleidoscope_1.SpinnerSize.Small }),
                        react_1.default.createElement(kaleidoscope_1.Text, null, " Fetching Data"))) : (react_1.default.createElement("div", { className: c("list-view-template-card-wrapper") },
                        react_1.default.createElement("img", { src: _this.images.templateIcon, alt: "" }),
                        react_1.default.createElement("div", { className: c("list-view-template-card-wrapper-details") },
                            react_1.default.createElement("div", { className: c("list-view-template-card-wrapper-details-left") },
                                react_1.default.createElement(kaleidoscope_1.Text, { strong: true, size: "l" }, displayedTemplate.name),
                                react_1.default.createElement("div", { className: c("list-view-template-card-wrapper-last-edited") },
                                    react_1.default.createElement(kaleidoscope_1.Text, { className: "show-hide", strong: true, size: "xs" }, "Last edited:"),
                                    react_1.default.createElement(kaleidoscope_1.Text, { className: "show-hide", size: "xs" }, new Date(displayedTemplate.lastEditedAt).toLocaleString()))),
                            react_1.default.createElement("div", { className: c("list-view-template-card-wrapper-details-right") },
                                react_1.default.createElement("div", { className: c("list-view-template-card-wrapper-details-right show-hide") },
                                    react_1.default.createElement(kaleidoscope_1.Text, { size: "xs" }, "Created by"),
                                    react_1.default.createElement(kaleidoscope_1.Text, { size: "s", strong: true },
                                        displayedTemplate.user.firstName,
                                        " ",
                                        displayedTemplate.user.lastName))))))),
                    _this.errorMessage && displayedTemplate._id === (template === null || template === void 0 ? void 0 : template._id) && (react_1.default.createElement(kaleidoscope_1.Alert, { className: c("error"), alertType: kaleidoscope_1.AlertType.Error, heading: "Error" }, _this.errorMessage)))); }))));
        }
        return (react_1.default.createElement("div", { className: c() },
            react_1.default.createElement("img", { className: c("icon"), src: this.images.objectIcon, alt: "" }),
            react_1.default.createElement(kaleidoscope_1.Heading, { className: c("heading"), level: "2" },
                "Select ",
                (0, utils_1.getSingularObjectName)({ object: objectType, integration: integrationName }).toLowerCase(),
                " template"),
            react_1.default.createElement(kaleidoscope_1.Text, { size: "s", secondary: true },
                "Select a template to base your ",
                (0, utils_1.getSingularObjectName)({ object: objectType, integration: integrationName }),
                " ",
                "record on."),
            templates));
    };
    var _a, _b, _c, _d, _e, _f, _g;
    __decorate([
        inversify_react_1.resolve,
        __metadata("design:type", typeof (_b = typeof CreatePageTelemetry_1.default !== "undefined" && CreatePageTelemetry_1.default) === "function" ? _b : Object)
    ], TemplateSelection.prototype, "telemetry", void 0);
    __decorate([
        inversify_react_1.resolve,
        __metadata("design:type", typeof (_c = typeof ApiService_1.ApiService !== "undefined" && ApiService_1.ApiService) === "function" ? _c : Object)
    ], TemplateSelection.prototype, "apiService", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Array)
    ], TemplateSelection.prototype, "displayedTemplates", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], TemplateSelection.prototype, "searchString", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], TemplateSelection.prototype, "errorMessage", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], TemplateSelection.prototype, "isLoading", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", typeof (_d = typeof SortBySelector_1.IMenuAsset !== "undefined" && SortBySelector_1.IMenuAsset) === "function" ? _d : Object)
    ], TemplateSelection.prototype, "selectedSortOption", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", typeof (_e = typeof DashboardTypes_1.SortDirection !== "undefined" && DashboardTypes_1.SortDirection) === "function" ? _e : Object)
    ], TemplateSelection.prototype, "selectedSortDirection", void 0);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_f = typeof SortBySelector_1.IMenuAsset !== "undefined" && SortBySelector_1.IMenuAsset) === "function" ? _f : Object]),
        __metadata("design:returntype", void 0)
    ], TemplateSelection.prototype, "setSelectedSortOption", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_g = typeof DashboardTypes_1.SortDirection !== "undefined" && DashboardTypes_1.SortDirection) === "function" ? _g : Object]),
        __metadata("design:returntype", void 0)
    ], TemplateSelection.prototype, "setSelectedSortDirection", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], TemplateSelection.prototype, "setSearchString", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], TemplateSelection.prototype, "setIsLoading", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], TemplateSelection.prototype, "setErrorMessage", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], TemplateSelection.prototype, "setDisplayedTemplates", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], TemplateSelection.prototype, "setSearchTerm", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], TemplateSelection.prototype, "setSortOption", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], TemplateSelection.prototype, "sortDisplayedTemplates", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], TemplateSelection.prototype, "reconfigureDisplayedTemplates", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], TemplateSelection.prototype, "selectTemplate", void 0);
    TemplateSelection = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [typeof (_a = typeof step_1.StepProps !== "undefined" && step_1.StepProps) === "function" ? _a : Object])
    ], TemplateSelection);
    return TemplateSelection;
}(react_1.default.Component));
exports.default = TemplateSelection;
